import {ElementTypes} from "@entities/widget-element";

export const maxDatasets = {
    [ElementTypes.CHART]: 5,
    [ElementTypes.DIAGRAM]: 5,
    [ElementTypes.SINGLE_VALUE]: 1,
    [ElementTypes.DEVICE_STATE]: 1,
    [ElementTypes.GAUGE]: 1,
};
